import { render } from "./DeviceHistory.vue?vue&type=template&id=4f3b1a67"
import script from "./DeviceHistory.vue?vue&type=script&lang=ts"
export * from "./DeviceHistory.vue?vue&type=script&lang=ts"
script.render = render

export default script